import {
  getStickyHeaderHeight,
  getMainSubheaderHeight,
  getSecondarySubheaderHeight,
  getSystemBannerHeight,
} from '@app/utils/domHelpers'

export const getTableTopOffset = (
  table: HTMLElement,
  scrollableElement: Element | Window
): number =>
  table.getBoundingClientRect().top +
  getScrollingPosition(scrollableElement) -
  getStickyTopOffset(scrollableElement)

export const getTableBottomOffset = (
  table: HTMLElement,
  scrollableElement: Element | Window
): number =>
  table.getBoundingClientRect().bottom +
  getScrollingPosition(scrollableElement) -
  getStickyTopOffset(scrollableElement)

// The viewport y a header has to be pinned to: the top edge of the scrolling
// box. A scrolling element reports that itself. When the window scrolls there
// is no such element, so the sticky page chrome above the content is measured
// instead.
export const getStickyTopOffset = (
  scrollableElement: Element | Window
): number =>
  scrollableElement instanceof Window
    ? getHeaderOffset()
    : scrollableElement.getBoundingClientRect().top

export const getHeaderOffset = (): number => {
  return [
    getStickyHeaderHeight(),
    getMainSubheaderHeight(),
    document.getElementById('secondary-subheader')
      ? getSecondarySubheaderHeight()
      : '0px',
    getSystemBannerHeight(),
  ].reduce((acc, height) => {
    return acc + parseInt(height.replace('px', ''), 10)
  }, 0)
}

export const getScrollingPosition = (
  scrollableElement: Element | Window
): number =>
  scrollableElement instanceof Window
    ? scrollableElement.scrollY
    : scrollableElement.scrollTop
